export default {
      id: "chevron-down-24-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-46b249.svg#chevron-down-24-usage",
      toString: function () {
        return this.url;
      }
    }